import Cards from '../Components/Cards';


export default function Home() {
  return (
    <div className="bg-white">

      <main className="isolate">
        {/* Hero section */}
        <div className="relative isolate -z-10 overflow-hidden bg-gradient-to-b from-indigo-100/20">
          <div
            className="absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:-mr-80 lg:-mr-96"
            aria-hidden="true"
          />
          <div className="mx-auto max-w-7xl px-6 py-32 sm:py-20 lg:px-8">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8">
              <h1 className="max-w-2xl text-4xl font-bold tracking-tight text-gray-900 sm:pt-40 sm:text-6xl lg:col-span-2 xl:col-auto">
                What is Helping Wheel?
              </h1>
              <div className="mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1">
                <p className="text-lg leading-8 text-gray-600">
                    Helping Wheel is a nonprofit organization that provides financial aid and equipment to
                    students from low-income households to be able to participate in afterschool activities.
                    This includes, sports that are provided by the school, clubs, and AP exams. We currently
                    operate within the counties of Spotsylvania, The City of Fredericksburg, King George,and Caroline.
                </p>
              </div>
              <img
                src="/images/HW Logo.jpg"
                alt="Helping Wheel logo"
                className=" aspect-[6/5] w-full max-w-lg rounded-2xl object-cover sm:mt-16 lg:max-w-none xl:row-span-2 xl:row-end-2 "
              />
            </div>
          </div>
          <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
        </div>

        {/* Cards */}
        <div className="mx-auto mt-10 max-w-7xl sm:px-6 lg:px-8">
          <div className="relative isolate overflow-hidden bg-gray-900 px-6 py-24 text-center shadow-2xl sm:rounded-3xl sm:px-16">
            <div className='mx-auto mt-6 align-center '>
              <Cards />
            </div>
          </div>
        </div>
      </main>


    </div>
  )
}
